import { Component, Input } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { MdSnackBar } from '@angular/material';
import { Product } from '../../models/Product';
import { Version } from '../../models/Version';
import { SoftwareService } from '../../shared/software.service';
import { AuthService } from '../../shared/auth.service';
import { Router } from '@angular/router';

@Component({
    selector: 'product',
    providers: [AuthService], 
    templateUrl: './product.component.html',
    styleUrls: ['./product.component.css']
})
export class ProductComponent {
    releaseStatus = [
        ['Prototype', 0],
        ['Alpha', 1],
        ['Beta', 2],
        ['Internal', 3],
        ['Dealership', 4],
        ['Production', 5],
        ['Obsolete', 6]
        ];

    product: Product = new Product();

    versions: Version[];
    latestProto: Version;
    latestAlpha: Version;
    latestBeta: Version;
    latestVersion: Version;

    busy: boolean = false;

    constructor(private softwareService: SoftwareService, public auth: AuthService, public snackBar: MdSnackBar, private route: ActivatedRoute, public router: Router) {
        let productId = route.snapshot.params['id'];
        if (productId > 0) {
            this.busy = true;
            this.getProduct(productId);
        }
    }

    async getProduct(id: number) {
        this.softwareService.getProductById(id).subscribe(result => {
            this.product = result.json();
            this.busy = false;

            this.softwareService.getLatestAlpha(this.product.UpdateId).subscribe(result => {
                this.latestAlpha = result.json();
            }, err => {
                this.latestAlpha = null;
            });
            this.softwareService.getLatestBeta(this.product.UpdateId).subscribe(result => {
                this.latestBeta = result.json();
            }, err => {
                this.latestBeta = null;
            });
            this.softwareService.getLatestProto(this.product.UpdateId).subscribe(result => {
                this.latestProto = result.json();
            }, err => {
                this.latestProto = null;
            });
            this.softwareService.getLatestVersion(this.product.UpdateId).subscribe(result => {
                this.latestVersion = result.json();
            }, err => {
                this.latestVersion = null;
            });
            this.softwareService.getVersions(this.product.UpdateId).subscribe(result => {
                this.versions = result.json();
            }, err => {
                this.versions = [];
            });

        }, err => {
            this.busy = false;
            this.product = new Product();
            this.snackBar.open('Error loading product', null, { duration: 3000 });
        });
    }

    
}



// WEBPACK FOOTER //
// ./Client/app/containers/product/product.component.ts